import { render, staticRenderFns } from "./DiskUpload.vue?vue&type=template&id=77156815&scoped=true&"
import script from "./DiskUpload.vue?vue&type=script&lang=js&"
export * from "./DiskUpload.vue?vue&type=script&lang=js&"
import style0 from "./DiskUpload.vue?vue&type=style&index=0&id=77156815&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77156815",
  null
  
)

export default component.exports